<style type="text/css" scoped>
.upload-csv-lable{
	height: 45;
	width:100%;
}

</style>

<template>
	<div>
		<v-row class="mb-5" >
			<v-col cols="9" md="6">
				<v-text-field
				v-model="product_serch_query"
				:placeholder="$lang.PRODUCT_SEARCH"
				outlined
				rounded
				dense
				append-icon="mdi-magnify"
				@keyup="getProductList"
				hide-details
				></v-text-field>
			</v-col>
			<v-col cols="3" md="2" class="text-right">
				<v-btn  rounded depressed  outlined  class="download-svg-btn px-0 v-align-bottom" width="151px" height="40"  @click="upload_dialog.flag=true"  >
					<img src="@/assets/upload.svg" alt="">
					{{$lang.UPLOAD_CSV}} 
				</v-btn>
			</v-col>
			<v-col cols="4" md="4" class="text-right">
				<v-btn color="primary" height="40" @click="$router.push({name:'new-product'})" >
					<b>{{$lang.ADD_PRODUCT}}</b>
				</v-btn>
			</v-col>
		</v-row>

		<v-data-table
		:headers="headers"
		:items="product_list"
		:hide-default-footer="true"
		:disable-sort="true"
		:items-per-page="$keys.PAGE_LENGTH"
		class="elevation-1 custome-header-bg custome-table-body"
		:loading="table_loading"
		>
		<template v-slot:item.action="{ item }">
			<v-btn small fab text @click="$router.push({name:'edit-product',params:{product_id:encript(item.id)}})">	
				<img src="@/assets/edit.svg" alt="img">
			</v-btn>	
			<v-btn small fab text class="ml-2"
			@click="confirmationDeleteProduct(item)">	
			<img src="@/assets/delete.svg" alt="img">
		</v-btn>	
	</template>	
	<template v-slot:no-data>
		<empty-list :message="$lang.EMPTY_PRODUCT"/>
	</template>	

</v-data-table>

<!-- pginations -->
<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
@input="product_list"></v-pagination>

<!--  -->

<confirmation-popup :dialog="dialog" @update-product-list="getProductList"/>


<uploadcsv-popup :dialog="upload_dialog" @update-product-list="getProductList" />

</div>
</template>

<script type="text/javascript">

export default{
	components:{
		ConfirmationPopup:()=> import('./child/ConfirmationPopup.vue'),
		UploadcsvPopup:()=> import('./child/UploadcsvPopup.vue'),
	},
	data(){
		return{
			upload_dialog:{
				flag:false
			},
			page_number:1,
			total_page_count:1,
			product_serch_query:"",
			table_loading:false,
			product_list:[],
			headers: [
			{
				text: 'Product',
				align: 'start',
				sortable: false,
				value: 'name',
			},
			{ text: 'Manufacture', value: 'product_manufacturer' },
			{ text: 'Formula', value: 'product_formula' },
			{ text: 'Offer', value: 'offer' },
			{ text: 'Price', value: 'product_price' },
			{ text: '', value: 'action' },
			],

			dialog:{
				flag:false,
				product_id:"",
				product_name:"",
			}
		}
	},
	created(){
		this.getProductList()
	},
	methods:{
		getProductList(){
			const self=this
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				search_query:this.product_serch_query,
			};
			self.table_loading=true;
			const successHandler = (response) => {
				self.product_list=response.data.product_list
				self.total_page_count=response.data.total_page_count

			};
			const finallyHandler = () => {
				self.table_loading=false
			};
			self.request_GET( self,self.$urls.PRODUCT_LIST,params,successHandler,null,null,finallyHandler)
		},
		confirmationDeleteProduct(product){
			this.dialog.product_id=product.id;
			this.dialog.product_name=product.name;
			this.dialog.flag=true;
		},

	}
}


</script>